import { MenuItemType } from '@/components/Menu'

import BusinessOutlined from '@mui/icons-material/BusinessOutlined'
import Link from '@mui/material/Link'
import { getSubsectionLink, PATHS_WITH_SECTIONS } from '@/router/RoutesUtils'
import ContactCardIcon from '@/components/Icons/ContactCardIcon'
import PersonOutlineIcon from '@/components/Icons/PersonOutlineIcon'
import BuildingBankIcon from '@/components/Icons/BuildingBankIcon'

export interface EditProfileNavItemType {
  id:
    | 'personal-info'
    | 'professional-license'
    | 'law-firm'
    | 'practice-areas'
    | 'education'
  label: string
  icon: JSX.Element
  route: string
  title: string
  subtitle: React.ReactNode
}

export const EDIT_PROFILE_NAV_ITEMS: EditProfileNavItemType[] = [
  {
    id: 'personal-info',
    label: 'Personal Information',
    route: 'personal-info',
    icon: <PersonOutlineIcon />,
    title: 'Personal Information',
    subtitle:
      'Introduce yourself to other members. Showcase your strengths to establish trust and credibility.',
  },
  {
    id: 'professional-license',
    label: 'Bar License',
    route: 'professional-license',
    icon: <ContactCardIcon />,
    title: 'Bar License',
    subtitle:
      'You have the option to add, remove, or edit your bar license information as needed.',
  },
  {
    id: 'law-firm',
    label: 'Law Firm',
    route: 'law-firm',
    icon: <BusinessOutlined sx={{ fontSize: '1rem' }} />,
    title: 'Law Firm',
    subtitle: 'What firm do you work for?',
  },
  {
    id: 'practice-areas',
    label: 'Practice Areas',
    route: 'practice-areas',
    icon: <BuildingBankIcon />,
    title: 'Practice Areas',
    subtitle: (
      <>
        The practice areas you list here will also act as filters for the New
        Case Alerts that you receive.{' '}
        <Link
          href="https://243216470.hs-sites-na2.com/as-help-center/hc/en-us/articles/25942737839899-managing-your-notifications"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn more here!
        </Link>
      </>
    ),
  },
]

// Utilities
export const getNavItemByRoute = (route: string) =>
  EDIT_PROFILE_NAV_ITEMS.find(item => item.route === route)

export const getNavItemById = (id: EditProfileNavItemType['id']) =>
  EDIT_PROFILE_NAV_ITEMS.find(item => item.id === id)

export const getDefaultNavItem = () => EDIT_PROFILE_NAV_ITEMS[0]

export const getEditPublicProfileFirstLink = () =>
  getSubsectionLink(
    PATHS_WITH_SECTIONS.EDIT_PUBLIC_PROFILE,
    getDefaultNavItem().route
  )

export const getMenuItems = (
  items: EditProfileNavItemType[]
): MenuItemType[] => [
  {
    sectionTitle: '',
    items: items.map(item => ({
      label: item.label,
      path: item.route,
      icon: item.icon,
    })),
  },
]
